export default __webpack_public_path__ + "static/media/trophy.15d56a2c.jpeg";